export default function getDisplayLg(display) {
  switch (display) {
    case "block":
      return "xl:block";
    case "inline-block":
      return "xl:inline-block";
    case "grid":
      return "xl:grid";
    case "inline":
      return "xl:inline-flex";
    case "row":
      return "xl:flex xl:flex-row";
    case "col":
      return "xl:flex xl:flex-col";
    case "row-reverse":
      return "xl:flex xl:flex-row-reverse";
    case "col-reverse":
      return "xl:flex xl:flex-col-reverse";
    case "none":
      return "xl:flex-none";
    case "contents":
      return "xl:contents";
    case "hidden":
      return "xl:hidden";
    default:
      return "";
  }
}
